{
  "invalidSelection": "Izabrani {selectedCount, plural, one {date} other {dates}} nije dostupan."
}
